import { UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { AtsUtility } from '@ats/utility';

export function numericOrder(fieldNames: string[], instanceName?: string): ValidatorFn {
	if (!fieldNames) throw new Error('Fields not supplied for validation');

	return (group: UntypedFormGroup): any => {
		const retVal: any = fieldNames.reduce((retVal: any, field, idx, arr): any => {
			const value = group.get(field)?.value;

			// If any of the values are not set, then we aren't ready to validate
			if (!AtsUtility.isTruthyOrZero(value) || isNaN(+value)) return { incomplete: true };

			// Already found an error, so no need to keep checking
			if (idx > 0 && retVal?.numericOrder) return retVal;

			const previous = idx > 0 ? +group.get(arr[idx - 1])?.value : null;

			if (AtsUtility.isTruthyOrZero(previous) && !isNaN(previous) && previous <= +value)
				return instanceName ? { [instanceName]: true } : { numericOrder: true };

			return null;
		}, null);
		return retVal?.incomplete ? null : retVal;
	};
}
